{
  "hints": {
    "howItWorks": "How it works",
    "chip": "{amount} {unit} — {hint}",
    "descents": {
      "s1t": "Pay at the door",
      "s1b": "A descent costs resolve once, when you step in.",
      "s2t": "Fight room by room",
      "s2b": "Wounds carry over. Turn back and you keep what you banked.",
      "s3t": "Take the spoils",
      "s3b": "Clear the last room for the full take — then the gate seals for a while."
    },
    "estates": {
      "s1t": "Take the ground",
      "s1b": "Walk to an estate on the map and beat its garrison.",
      "s2t": "Rent piles up",
      "s2b": "A held estate earns folles every hour, until its strongroom is full.",
      "s3t": "Collect and hold",
      "s3b": "Collect before it fills, raise its level, and break any siege in time.",
      "stored": "Strongroom {amount} / {cap}"
    },
    "amphitheatre": {
      "s1t": "Enter the queue",
      "s1b": "A foe near your rating is found. You may leave this screen meanwhile.",
      "s2t": "Accept in time",
      "s2b": "When a foe is called, fight before the sand-glass runs out.",
      "s3t": "Win rating",
      "s3b": "Victory pays folles and rating; defeat costs both.",
      "emptyBody": "Enter the Amphitheatre above — your first bout will be written here."
    },
    "factions": {
      "s1t": "Find a standard",
      "s1b": "Search the roll and ask to join — or raise your own.",
      "s2t": "The leader answers",
      "s2b": "Your plea waits until the leader lets you in.",
      "s3t": "Climb together",
      "s3b": "Every sworn member's age points add up on the faction tablet."
    },
    "moneychanger": {
      "s1t": "Bring solidi",
      "s1b": "Pick a package, or name your own amount.",
      "s2t": "The changer's cut",
      "s2b": "{pct}% comes off the gross before you are paid.",
      "s3t": "Folles in your purse",
      "s3b": "Credited at once — spend them at the Forum."
    },
    "empty": {
      "strongboxTitle": "The strongbox is bare",
      "dealsTitle": "No deals posted right now",
      "dealsBody": "Fresh offers go up with the new day. The regular packs are always open.",
      "dealsCta": "See the packs",
      "chat": "The Rostra is quiet. Say hail."
    }
  },
  "notifications": {
    "bell": "Notifications",
    "bellUnread": "Notifications, {count} unread",
    "title": "Notifications",
    "markAllRead": "Mark all read",
    "close": "Close notifications",
    "loading": "Asking the couriers…",
    "loadFailed": "The notifications could not be fetched.",
    "retry": "Try again",
    "empty": "No news yet — the couriers are quiet.",
    "loadMore": "Older notifications",
    "unread": "Unread",
    "someone": "Someone",
    "arrived": "New notification: {text}",
    "answerFailed": "That plea could not be answered.",
    "outcome": {
      "accepted": "Let in",
      "declined": "Turned away",
      "withdrawn": "Withdrawn"
    },
    "type": {
      "clan": {
        "join_request": "{username} pleads to join [{clanTag}] {clanName}.",
        "request_accepted": "Your plea was accepted — you are sworn to [{clanTag}] {clanName}.",
        "request_declined": "[{clanTag}] {clanName} turned your plea away.",
        "kicked": "You were cast out of [{clanTag}] {clanName}.",
        "leadership": "You now lead [{clanTag}] {clanName}."
      },
      "purchase": {
        "completed": "Purchase complete: {bars} solidi for {price}.",
        "completedPlain": "Purchase complete: {price}."
      },
      "estate": {
        "siege": "Raiders lay siege to {territoryName} — defend it by {deadline}.",
        "lost": "{territoryName} fell — the siege went unanswered.",
        "taken": "{username} took {territoryName} from you."
      },
      "withdrawal": {
        "requested": "Withdrawal requested: {solidi} solidi held for a payout of {payout}.",
        "approved": "Your withdrawal of {payout} was approved and is on its way to your bank.",
        "rejected": "Your withdrawal was rejected: {reason}. {solidi} solidi are back in your purse.",
        "rejectedPlain": "Your withdrawal was rejected. {solidi} solidi are back in your purse."
      },
      "unknown": "Something happened."
    }
  },
  "common": {
    "loading": "Loading…",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved",
    "clear": "Clear",
    "copy": "Copy",
    "copied": "Copied!",
    "cancel": "Cancel",
    "close": "Close",
    "verify": "Verify",
    "working": "…",
    "none": "—",
    "selectCountry": "Select country…",
    "pdf": "PDF",
    "folles": "Folles",
    "loadMore": "Load more",
    "itemsLeft": "{count} left",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "pageN": "Page {page}"
  },
  "money": {
    "chargeNote": "Shown as an estimate — you will be charged in {currency}.",
    "chargeNoteShort": "Charged in {currency}"
  },
  "shop": {
    "kicker": "Imperial treasury",
    "title": "The Treasury",
    "balance": "Balance",
    "solidiUnit": "Solidi",
    "buyNow": "Buy now",
    "processing": "Processing…",
    "grab": "Take it",
    "tabs": {
      "buy": "Buy solidi",
      "deals": "Special offers",
      "withdraw": "Withdraw"
    },
    "withdraw": {
      "kicker": "The Treasury",
      "title": "Withdraw to your bank",
      "rule": "You can withdraw up to what you have deposited, less the {fee} fee — never more than you put in.",
      "earnedNote": "Solidi earned in play (selling items, rewards) can be spent in the game but not withdrawn.",
      "deposited": "Deposited",
      "withdrawn": "Already withdrawn",
      "pendingLabel": "Awaiting review",
      "withdrawable": "Withdrawable now",
      "upTo": "up to {amount}",
      "amount": "Amount to withdraw (solidi)",
      "max": "Max",
      "minimum": "Minimum payout {amount} — at least {solidi} solidi.",
      "wholeNumber": "Enter a whole number of solidi.",
      "tooMuch": "You can withdraw at most {amount} solidi.",
      "tooLittle": "That is below the minimum payout of {amount}.",
      "held": "Solidi held",
      "fee": "Fee ({percent})",
      "payout": "You receive",
      "holder": "Account holder",
      "iban": "IBAN",
      "ibanInvalid": "That IBAN does not check out — look at it again.",
      "submit": "Request withdrawal",
      "invoiceNote": "Once the payout is made, its invoice appears in Settings → Invoices.",
      "kyc": "Payouts need verified identity papers.",
      "kycPending": "Your papers are being reviewed — withdrawals open once they are approved.",
      "kycCta": "Verify in Settings → Papers",
      "billing": "Complete your billing details in Settings before withdrawing — they are printed on the payout invoice.",
      "nothing": "Nothing to withdraw yet — only deposited solidi can be cashed out, and the payout must reach {amount}.",
      "pendingTitle": "Request awaiting review",
      "pendingText": "{solidi} solidi held — {payout} to {iban}. Filed {date}.",
      "historyTitle": "Withdrawal history",
      "historyEmpty": "No withdrawals yet.",
      "reason": "Reason: {reason}",
      "status": {
        "PENDING": "Pending",
        "APPROVED": "Paid out",
        "REJECTED": "Rejected — solidi returned"
      },
      "confirmTitle": "Withdraw {solidi} solidi?",
      "confirmNote": "The solidi are held from now on. If the request is rejected, they come back to you.",
      "confirmCta": "Withdraw {amount}",
      "requested": "Withdrawal requested — you will be notified when it is reviewed."
    },
    "redirecting": {
      "title": "Redirecting to payment…",
      "desc": "You will be taken to the secure checkout."
    },
    "kyc": {
      "text": "The Curia checks names on large sums — purchases of {amount} or more require identity verification.",
      "textPending": "The Curia checks names on large sums — purchases of {amount} or more require identity verification (yours is under review)."
    },
    "granted": "{amount} gold solidi added to your account.",
    "toast": {
      "granted": "{amount} solidi — the treasury holds"
    },
    "ribbon": {
      "popular": "Popular",
      "bestValue": "Best value"
    },
    "custom": {
      "title": "Name your own amount",
      "desc": "Any amount from {min} to {max} solidi — base rate, no bundle bonus.",
      "unit": "solidi",
      "buy": "Buy custom",
      "invalid": "Enter a whole number between {min} and {max}."
    },
    "deals": {
      "title": "Today's deals",
      "desc": "More gold for your money — twenty offers posted in the forum.",
      "endsIn": "Ends in",
      "timeLeft": "Time left",
      "priceChanged": "Fresh prices are up — this deal now costs {price}. Check it and try again."
    },
    "confirm": {
      "kicker": "The Treasury",
      "offerKicker": "Special offer",
      "buyTitle": "Buy {name}?",
      "customTitle": "Buy {count} solidi?",
      "grabTitle": "Grab {name}?",
      "credited": "Credited to account",
      "total": "Total",
      "was": "Was",
      "totalSaving": "Total −{percent}%",
      "pay": "Pay {amount}",
      "note": "Real-money purchase — your card will be charged."
    },
    "footnote": {
      "buy": "Every buy is credited in full — no commission.",
      "receipts": "Looking for receipts? Purchases, invoices & transactions moved to {location}.",
      "receiptsLocation": "Settings → Billing"
    },
    "billing": {
      "text": "Your billing details must be complete before you can buy — they are printed on the invoice.",
      "missing": "Still needed: {fields}.",
      "cta": "Open Settings",
      "field": {
        "firstName": "name",
        "lastName": "surname",
        "line1": "street address",
        "postalCode": "postal code",
        "city": "city",
        "country": "country"
      }
    }
  },
  "settings": {
    "title": "The Wax Tablets",
    "tabs": {
      "account": "Account",
      "papers": "Papers",
      "referral": "Referral",
      "purchases": "Purchases",
      "invoices": "Invoices",
      "transactions": "Transactions",
      "danger": "Danger Zone"
    },
    "oath": {
      "anonymous": "PLAYER",
      "swornIn": "Enrolled {date}",
      "classLevel": "{class} · Lv.{level}",
      "solidi": "{count} solidi",
      "adminPanel": "Admin panel ↗"
    },
    "marks": {
      "emailVerified": "Email verified",
      "emailUnverified": "Email not verified.",
      "verifySent": "Verification sent — check your inbox.",
      "papersLink": "Papers ›"
    },
    "prefs": {
      "title": "Tongue & coin",
      "locale": {
        "label": "Language",
        "desc": "The tongue the Curia speaks to you in."
      },
      "currency": {
        "label": "Currency",
        "desc": "What prices are shown in."
      },
      "localeSaved": "The Curia speaks {language} now.",
      "currencySaved": "Prices now shown in {currency}."
    },
    "profile": {
      "title": "Profile",
      "phone": {
        "label": "Phone",
        "desc": "From registration."
      },
      "country": {
        "label": "Country",
        "saved": "Country saved."
      },
      "firstName": {
        "label": "Name"
      },
      "lastName": {
        "label": "Surname"
      },
      "saveDetails": "Save details",
      "detailsSaved": "Details saved.",
      "billing": {
        "title": "Billing address",
        "desc": "Printed on every invoice, beside your name. Required before you can buy.",
        "line1": "Street and number",
        "line2": "Flat, entrance (optional)",
        "postalCode": "Postal code",
        "city": "City",
        "saved": "Billing address saved."
      }
    },
    "password": {
      "title": "Change password",
      "current": "Current password",
      "new": "New password (8+ characters)",
      "confirm": "Confirm new password",
      "submit": "Save password",
      "changed": "Password changed.",
      "tooShort": "New password must be at least 8 characters.",
      "mismatch": "Passwords do not match."
    },
    "kyc": {
      "approved": "Papers in order — identity verified",
      "pending": "Papers with the Curia — under review",
      "rejected": "Papers rejected",
      "none": "Papers not submitted"
    },
    "papers": {
      "title": "Identity papers",
      "disabled": "The Curia isn't checking papers right now — verification is disabled.",
      "approved": "Papers in order — your identity is verified.",
      "pending": "Your papers are with the Curia — under review.",
      "submittedOn": "Submitted {date}.",
      "rejected": "Papers rejected. Submit again below.",
      "rejectedWithReason": "Papers rejected — {reason}. Submit again below.",
      "intro": "Purchases over the Curia's limit need verified papers. One government ID (photo or PDF) and your particulars — reviewed by the Curia, usually within a day.",
      "fullName": "Full legal name",
      "fullNameHint": "As printed on the document",
      "dob": "Date of birth",
      "address": "Residential address",
      "addressHint": "Street, city, postal code",
      "country": "Country",
      "document": "Identity document",
      "submit": "Submit papers",
      "submitting": "Submitting…",
      "submitted": "Papers submitted — the Curia will review them.",
      "legal": {
        "title": "Legal documents",
        "intro": "The terms this realm runs under — published and kept current by the Curia.",
        "view": "Read"
      }
    },
    "referral": {
      "title": "Referral",
      "loadFailed": "Could not load referral info.",
      "intro": "Bring a friend into the faction — they start with +{reward} folles.",
      "link": {
        "label": "Your link",
        "desc": "Share it — new hands get a head start."
      }
    },
    "purchases": {
      "title": "Purchases",
      "empty": "No purchases yet.",
      "line": "{pack} — {count} solidi",
      "openTreasury": "Open the Treasury",
      "status": {
        "COMPLETED": "Completed",
        "PENDING": "Pending",
        "FAILED": "Failed",
        "REFUNDED": "Refunded"
      }
    },
    "invoices": {
      "title": "Invoices",
      "empty": "No invoices yet.",
      "downloadFailed": "Could not download the invoice — try again.",
      "status": {
        "PAID": "Paid",
        "PENDING": "Not paid",
        "CANCELLED": "Cancelled"
      },
      "type": {
        "IN": "Deposit",
        "OUT": "Payout"
      }
    },
    "transactions": {
      "title": "Transactions",
      "empty": "No movements yet — every follis and solidus that changes hands shows up here.",
      "when": "When",
      "detail": "Detail",
      "amount": "Amount",
      "balance": "Balance"
    },
    "sound": {
      "title": "Sound",
      "music": {
        "label": "Music",
        "desc": "The low drone under every screen."
      },
      "effects": {
        "label": "Combat effects",
        "desc": "Weapon and impact sounds in fights."
      },
      "on": "On",
      "off": "Off"
    },
    "danger": {
      "title": "Danger Zone",
      "kicker": "The Danger Zone",
      "intro": "Retiring your character wipes it and every item you own — you're paid back 20% of what it was all worth.",
      "inventoryValue": "Inventory value",
      "inventoryValueDesc": "Total worth of everything you own, gear you're wearing included.",
      "compensation": "Compensation (20%)",
      "compensationDesc": "What you'll be paid the moment you retire.",
      "rerollSectionTitle": "Change Class",
      "rerollSectionDesc": "Wipes your gear and starts you over as a new class, with the same starting folles and gear a fresh recruit gets.",
      "pickClass": "New class",
      "newName": "New name (optional)",
      "rerollConfirm": "Change Class",
      "rerollTitle": "Reroll into a {class}?",
      "rerollNote": "Your gear is gone. This cannot be undone.",
      "deleteWarning": "Deleting your character removes it permanently — you'll start from scratch.",
      "deleteConfirm": "Delete Character",
      "deleteTitle": "Delete your character?",
      "deleteNote": "This cannot be undone."
    }
  },
  "nav": {
    "profile": "Hero",
    "map": "Italia",
    "districts": "Estates",
    "market": "The Forum",
    "jobs": "Commissions",
    "rankings": "Rankings",
    "dungeons": "Descents",
    "amphitheatre": "The Amphitheatre",
    "settings": "Settings",
    "signOut": "Sign out",
    "openMenu": "Open menu",
    "settingsTitle": "Account, papers & purchases",
    "guide": "Codex",
    "clans": "Factions",
    "menu": "Menu",
    "closeMenu": "Close menu"
  },
  "forum": {
    "open": "The Rostra — word from every sworn hand",
    "close": "Close the Rostra",
    "label": "The Rostra"
  },
  "classes": {
    "WARRIOR": {
      "name": "Veteran Centurion",
      "epithet": "Holder of the Line",
      "blurb": "Shield and formation. Soaks blows, holds the ground, hits back harder."
    },
    "PALADIN": {
      "name": "Mithraist",
      "epithet": "Sworn of the Unconquered Sun",
      "blurb": "Warrior-priest of a dimmed sun. Balanced, keeps the company standing."
    },
    "ARCHER": {
      "name": "Gothic Jarl",
      "epithet": "Rider of the Goths",
      "blurb": "Raider and horseman. High damage, thin armour."
    },
    "MAGE": {
      "name": "Haruspex",
      "epithet": "Reader of Livers",
      "blurb": "The omen-reader. Burst damage and curses that unsettle the dead."
    }
  },
  "hero": {
    "create": {
      "nameLabel": "Name",
      "submit": "Inscribe the name",
      "submitting": "Inscribing…",
      "errName": "Pick a name (2+ characters).",
      "errClass": "Choose a class."
    }
  },
  "switcher": {
    "language": "Language",
    "chooseLanguage": "Choose your language"
  },
  "landing": {
    "nav": {
      "home": "Home",
      "callings": "Callings",
      "city": "Italia",
      "rise": "Ranks",
      "faq": "FAQ",
      "news": "Chronicle",
      "play": "Play Free",
      "menu": "Menu",
      "primary": "Primary",
      "mobile": "Mobile",
      "guide": "Codex"
    },
    "hero": {
      "kick": "Italy, 536 AD — the year the sun shone like the moon",
      "title1": "Gather your faction.",
      "title2": "Outlast the dark.",
      "sub": "Hold the granaries, keep the roads, and climb from refugee to patrician while frost falls in summer and the tenth age runs out.",
      "how": "How it works",
      "free": "Free to play",
      "browser": "In your browser",
      "noDownload": "No download"
    },
    "callings": {
      "heading": "Choose your calling",
      "sub": "Four callings. One oath. Every calling you take changes how a failing Italy bends around you.",
      "mithraist": {
        "name": "The Mithraist",
        "role": "Warrior-priest of the Unconquered Sun. Tribute income and a steady company."
      },
      "centurion": {
        "name": "The Veteran Centurion",
        "role": "Shield and formation. Takes ground and holds it."
      },
      "jarl": {
        "name": "The Gothic Jarl",
        "role": "Lethal on the old roads. Raids, horsemen and mercenaries."
      },
      "haruspex": {
        "name": "The Haruspex",
        "role": "Reader of omens and entrails. Quiets the restless dead."
      }
    },
    "how": {
      "heading": "How a faction rises",
      "sub": "Four moves, one failing land — cut into the tablets so no one forgets the order.",
      "build": {
        "h": "Build",
        "p": "Stand up tributes across the estates — granaries, mills, protection — and grow your company from a burnt villa to a province."
      },
      "earn": {
        "h": "Gather",
        "p": "Collect the tribute, weigh every coin true, and change bronze for gold before the famine catches up."
      },
      "war": {
        "h": "War",
        "p": "Raid rival estates, drive their men off the roads, and make examples the whole peninsula remembers."
      },
      "conquer": {
        "h": "Conquer",
        "p": "Seize ground estate by estate and hold it — contested land never stays contested for long."
      }
    },
    "city": {
      "heading": "Take Italy",
      "sub": "Twelve regions. Eight tiers. One dying land — and every region already belongs to someone.",
      "holdName": "Italia",
      "who": "Who stands between you and the curule chair:",
      "more": "…and seven more regions under the dust veil, each held by a faction that will not hand it over.",
      "tier1": "Tier I",
      "tier2": "Tier II",
      "tier3": "Tier III",
      "tier4": "Tier IV",
      "tier5": "Tier V",
      "tier6": "Tier VI",
      "tier7": "Tier VII",
      "tier8": "Tier VIII",
      "w1": {
        "n": "The Bay of Naples",
        "c": "The Dust-Farmers"
      },
      "w2": {
        "n": "Rome of the Ruins",
        "c": "The Catacomb Brotherhood"
      },
      "w3": {
        "n": "The Ravenna Marshes",
        "c": "The Gothic Court"
      },
      "w4": {
        "n": "The Etruscan Necropolis",
        "c": "The College of Haruspices"
      },
      "w5": {
        "n": "The Lake of Avernus",
        "c": "The Sibyl's Keepers"
      },
      "w6": {
        "n": "Cumae of the Sibyl",
        "c": "The Oracle Wardens"
      },
      "w7": {
        "n": "Campania Under Ash",
        "c": "The Grain Houses"
      },
      "w8": {
        "n": "The Appian Way",
        "c": "The Milestone Lamiae"
      },
      "w9": {
        "n": "The Flaminian Way",
        "c": "The Deserter Bands"
      },
      "w10": {
        "n": "The Apennine Passes",
        "c": "The Wolf Clans"
      },
      "w11": {
        "n": "The Sicilian Ports",
        "c": "The Grain Fleet"
      },
      "w12": {
        "n": "The Alpine Marches",
        "c": "The Frost Wardens"
      }
    },
    "rise": {
      "heading": "Rise to Patrician",
      "sub": "Six ranks between the ash and the curule chair — and every promotion pays out.",
      "pts": "{n} pts",
      "r1": {
        "n": "Refugee",
        "p": "Fresh off the burnt fields — small errands, low profile, earning your bread."
      },
      "r2": {
        "n": "Colonus",
        "p": "Bound to a plot of grey earth — but the faction is starting to remember your name."
      },
      "r3": {
        "n": "Plebeian",
        "p": "A citizen of the plebs at last. You hold ground and answer to no refugee."
      },
      "r4": {
        "n": "Eques",
        "p": "A horse and a gold ring of your own. You lead a company, and the tributes answer to you."
      },
      "r5": {
        "n": "Senator",
        "p": "A seat in the Curia, second only to the Patrician. A whole region moves on your word."
      },
      "r6": {
        "n": "Patrician",
        "p": "What is left of Italy is yours. Every sworn hand knows who sits in the curule chair."
      }
    },
    "faq": {
      "heading": "Questions & answers",
      "q1": "Is Caligo 536 free to play?",
      "a1": "Yes. Every core system — ground, tribute, company, combat — is free. Gold solidi can speed things up, but nothing that decides a war sits behind a paywall.",
      "q2": "Do I need to download anything?",
      "a2": "No. Caligo 536 runs entirely in your browser, on desktop or mobile. Make an account and you are on the Bay of Naples in seconds.",
      "q3": "What exactly is Caligo 536?",
      "a3": "A grim strategy game set in Italy, 536 AD, when a dust veil dimmed the sun, frost fell in summer and the Gothic War tore the land apart. Build a faction, run tributes, take ground estate by estate, and climb from refugee to patrician.",
      "q4": "How do factions work?",
      "a4": "Factions are player-run companies. Join one for protection and shared tribute, or found your own and recruit fighters to run a whole region.",
      "q5": "Can I lose my progress?",
      "a5": "Ground changes hands, but your character, gear, and rank persist. Each age resets the map — never your legacy.",
      "q6": "How do I get started?",
      "a6": "Pick your calling, claim your first estate, and run a tribute. The in-game walkthrough takes you through your first steps."
    },
    "finale": {
      "kicker": "No oaths broken. No download. No mercy.",
      "heading": "The dark is waiting.",
      "sub": "Make your first move tonight — it's free to play, and the age is already running out.",
      "cta": "Play Free Now"
    },
    "footer": {
      "legal": "Legal",
      "colGame": "Game",
      "colFollow": "Follow",
      "terms": "Terms of Service",
      "privacy": "Privacy Policy",
      "cookies": "Cookie Policy",
      "contact": "Contact Us",
      "faq": "FAQ",
      "copyright": "© {year} {name}. All rights reserved.",
      "socialOn": "Caligo 536 on {platform}",
      "socialGeneric": "Caligo 536 social link",
      "payments": "Accepted payment methods",
      "securityNote": "Payments are processed by a PCI DSS compliant payment provider. Card payments are protected with 3-D Secure authentication."
    }
  },
  "auth": {
    "login": {
      "heading": "Welcome back",
      "sub": "Sign in to continue.",
      "email": "Email",
      "password": "Password",
      "submit": "Sign in",
      "submitting": "Signing in…",
      "showPassword": "Show password",
      "verifyWait": "Please wait for verification to complete.",
      "forgot": "Forgot password?",
      "create": "Create account"
    },
    "register": {
      "heading": "Create an account",
      "sub": "It takes less than a minute.",
      "username": "Username",
      "email": "Email",
      "phone": "Phone",
      "phoneOptional": "(optional)",
      "phonePlaceholder": "+1 555 000 0000",
      "password": "Password (min 8 chars)",
      "confirmPassword": "Confirm password",
      "submit": "Create account",
      "submitting": "Creating…",
      "show": "Show",
      "hide": "Hide",
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "errUsername": "Pick a username — the census needs a name for you.",
      "errPassword": "Password must be at least 8 characters.",
      "errMismatch": "Passwords don't match.",
      "errPhone": "That phone number does not look right.",
      "errTerms": "You must accept the Terms of Service and Privacy Policy.",
      "errVerify": "Please wait for verification to complete.",
      "termsAgree": "I agree to the",
      "terms": "Terms of Service",
      "privacy": "Privacy Policy",
      "haveAccount": "Have an account?",
      "signIn": "Sign in",
      "and": "and",
      "errPasswordLength": "Password must be at least 8 characters.",
      "errPasswordMatch": "Passwords don't match."
    },
    "forgot": {
      "heading": "Reset password",
      "sub": "Enter your email and we'll send a reset link.",
      "email": "Email",
      "submit": "Send reset link",
      "submitting": "Sending…",
      "success": "If that email exists, we sent a reset link. Check your inbox.",
      "errVerify": "Please wait for verification to complete.",
      "backToSignIn": "Back to sign in",
      "verifyWait": "Please wait for verification to complete."
    },
    "reset": {
      "heading": "Choose a new password",
      "sub": "You'll be redirected to sign in after reset.",
      "password": "New password (min 8 chars)",
      "submit": "Set new password",
      "submitting": "Saving…",
      "errVerify": "Please wait for verification to complete.",
      "verifyWait": "Please wait for verification to complete."
    },
    "checkEmail": {
      "heading": "Verify your email",
      "sentTo": "We sent a verification link to",
      "checkInbox": "Check your inbox and click the link to continue.",
      "signOut": "Sign out"
    },
    "verify": {
      "heading": "Verifying email…",
      "status": "One moment.",
      "success": "Email verified. You can now sign in.",
      "failed": "Verification failed: {error}",
      "backToSignIn": "Back to sign in"
    }
  },
  "verifyRedirect": {
    "heading": "Email verified",
    "note": "Taking you inside…",
    "enter": "Enter now"
  },
  "connection": {
    "lost": "Connection lost — reconnecting…"
  },
  "arena": {
    "title": "The Amphitheatre",
    "sub": "Ranked · sworn vs sworn",
    "rating": "{rating} rating",
    "enter": "Enter the Amphitheatre",
    "firstBlood": "First blood settles it",
    "searching": "Searching for a foe · {seconds}s",
    "leaveQueue": "Leave queue",
    "stake": "Stake",
    "fight": "Fight",
    "cancel": "Cancel",
    "cancelWithRating": "Cancel · −{rating} rating",
    "cancelCharged": "You walked away — {rating} rating forfeited.",
    "holdLeft": "Accept within {time}",
    "holdExpired": "The challenger walked. Search again.",
    "challengerWaits": "A challenger waits",
    "crowdHolds": "The crowd holds its breath",
    "wins": "Wins",
    "losses": "Losses",
    "winStreak": "Win streak",
    "noStreak": "No streak",
    "recordTitle": "Record of Bouts",
    "vs": "vs {opponent}",
    "victory": "Victory",
    "defeat": "Defeat",
    "ratingLabel": "Rating",
    "empty": "No bouts yet — the sand waits.",
    "foeLevel": "Lv {level}",
    "searchingAria": "Searching for a foe",
    "stakes": {
      "costs": "Costs",
      "win": "Win",
      "lose": "Lose",
      "fury": "resolve",
      "folles": "folles",
      "rating": "rating"
    },
    "confirm": {
      "title": "Face {name}?",
      "foe": "Foe",
      "note": "Deciding costs nothing — the sand-glass keeps running, and if it runs out the foe simply walks. No fee, no rating moved.",
      "later": "Not yet"
    }
  },
  "battle": {
    "you": "You",
    "round": "Round {n}",
    "yourMove": "Your move",
    "goesCold": "Goes cold in {time}",
    "room": "Room {current}/{total}",
    "defender": "Defender {current}/{total}",
    "banked": "Banked {amount}",
    "leave": "Leave",
    "walkOut": "Walk out",
    "lv": "Lv{level}",
    "down": "Down",
    "block": "BLOCK",
    "patched": "PATCHED",
    "outcome": {
      "walkAmphitheatre": "Walked out of the Amphitheatre",
      "winAmphitheatre": "You win in the Amphitheatre",
      "loseAmphitheatre": "Beaten in the Amphitheatre",
      "gotAway": "Got away",
      "groundTaken": "Ground taken",
      "beatenBack": "Beaten back",
      "victory": "Victory",
      "beaten": "Beaten",
      "tooSlow": "Too slow — the watch rolled up",
      "gotOut": "Got out alive",
      "jobDone": "Job done",
      "jobBlown": "Job blown",
      "walkedOut": "You walked out",
      "youWin": "You win"
    },
    "confirm": {
      "kicker": "The Amphitheatre",
      "walkOutTitle": "Walk out of the bout?",
      "walkOutNote": "Leaving mid-fight is a forfeit — it counts as a loss, same as getting dropped. Rating and stake settle accordingly.",
      "walkOutConfirm": "Walk out (forfeit)",
      "keepFighting": "Keep fighting",
      "dropTitle": "Leave the sand?",
      "dropNote": "Nothing is staked yet — the challenger is simply let go. No resolve spent, no rating moved.",
      "dropNoteRating": "The foe is already matched. Walking out costs {rating} rating — less than a loss, but the ladder remembers. No resolve spent, no folles moved.",
      "dropConfirm": "Let them go",
      "dropConfirmRating": "Let them go (−{rating} rating)",
      "stay": "Stay on the sand"
    },
    "cold": {
      "title": "The fight went cold",
      "desc": "Nobody struck a blow for five minutes — both sides drifted off. No blood, no spoils.",
      "walkAway": "Walk away"
    },
    "roomClear": "Room clear",
    "roomCut": "This chamber's cut",
    "nextUp": "Next up: {name}",
    "wayOpen": "The way ahead is open.",
    "bankedLabel": "banked",
    "pressOn": "Press on",
    "takeTheTake": "Take the take",
    "cooling": "Cooling",
    "left": "{count} left",
    "folles": "folles",
    "collectAndGo": "Collect and go",
    "walkItOff": "Walk it off",
    "squaringUp": "Squaring up…",
    "levelUp": "Level up — Level {level}",
    "ratingLabel": "Rating",
    "recordLabel": "Record",
    "winStreakN": "{n}-win streak",
    "lossSkidN": "{n}-loss skid",
    "liftedOff": "Lifted off him",
    "paidOut": "Paid out",
    "theTake": "The take",
    "reputation": "Reputation",
    "bankedFromJob": "Banked from the job",
    "liftedOffBody": "Lifted off the body",
    "districtTaken": "The estate answers to you now. Collect the tribute from the Estates screen.",
    "interRoom": {
      "jobStillOn": "The job's still on",
      "roomCleared": "Room {n} cleared",
      "bankedSoFar": "Banked so far",
      "waitingNextChamber": "Waiting in the next chamber",
      "patchUp": "Patch up · {count} left",
      "bailOut": "Bail out — keep the take"
    },
    "actionBar": {
      "roundMove": "Round {n} — your move",
      "unmute": "Unmute",
      "mute": "Mute",
      "patchUps": "Patch-ups: {count}",
      "strike": "Strike",
      "quickShot": "Quick shot",
      "heavy": "Heavy",
      "bigHitRisky": "Big hit · risky",
      "guard": "Guard",
      "braceBlock": "Brace · block",
      "specialReady": "Special · ready",
      "cooldown": "Cooldown {n}",
      "patchUp": "Patch up",
      "flee": "Flee",
      "bailOut": "Bail out"
    },
    "ashRemembers": "The ash will remember this",
    "darkCollects": "The dark collects its due",
    "wordFromRoads": "Word from the roads",
    "noDice": "No dice",
    "walkAway": "Walk away",
    "obolSpent": "Charon's Obol spent",
    "fightTime": "Fight time",
    "weighingStrike": "Weighing the strike",
    "fleeFailed": "FLIGHT BLOCKED",
    "stillFighting": "You are still in a fight — finish it first.",
    "solidi": "solidi",
    "flask": "Flask of Posca",
    "flaskUsed": "Flask drained",
    "stats": {
      "strike": "Damage {min}–{max} · crit {crit}%",
      "heavy": "Damage {min}–{max}, lands {hit}% · their blow +{extra}%",
      "guard": "Your blow −{deal}% · their blow −{take}% · full block {block}%",
      "flee": "Escape odds {pct}%",
      "heal": "Mend {pct}% of your health"
    },
    "standingLabel": "Standing",
    "roomConfirm": {
      "note": "Or take the take — walk out now and keep what is banked.",
      "stay": "Not yet"
    },
    "vigorCost": "vigor",
    "vigorTitle": "Vigor — the fight's own energy. The big moves spend it; the Flask of Posca refills it. Strike and guard are always free."
  },
  "city": {
    "title": "Italia",
    "loading": "Drawing Italia…",
    "openCountry": "The open country",
    "fury": "Resolve",
    "furyOf": "Resolve {current} of {max}",
    "furyDesc": "Resolve — your will to keep going under a dead sun. Moving across the map and starting fights both spend it. It creeps back up (+1 every 2.5 minutes…); when you're low, drink a Flask of Posca to refill.",
    "noWayThrough": "No way through",
    "move": "Move",
    "furyCost": "resolve",
    "scoutingRoads": "Scouting the roads…",
    "center": "Center",
    "zoom": "Zoom",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomReset": "Zoom {pct}% — reset to 100%",
    "noRoute": "No route to that target.",
    "locked": "{name} is locked — reach level {level} to take it.",
    "crossedInto": "You've crossed into",
    "tier": "Tier {n}",
    "yourGround": "your ground",
    "dismiss": "Dismiss",
    "tierYourGround": "TIER {n} · YOUR GROUND",
    "tierLocked": "TIER {n} · LOCKED · LV {level}",
    "tierTakeIt": "TIER {n} · TAKE IT",
    "lockedUntil": "The stronghold won't open its gates until LV {level}.",
    "danger": {
      "deadly": "Deadly",
      "deadlyNote": "Far above your weight. Walking away is not cowardice.",
      "risky": "Risky",
      "riskyNote": "They hit above your weight here. Bring your best.",
      "easyPrey": "Easy prey",
      "easyNote": "This one will not take long.",
      "fairFight": "Fair fight",
      "fairNote": "An even match — make it count."
    },
    "estate": {
      "farAbove": "Word from the roads: their sworn are far above your weight. Walk carefully — or walk away.",
      "aboveWeight": "Their sworn hit above your weight here. Pick your fights.",
      "yourName": "This land knows your name. Collect what you're owed.",
      "canHandle": "You can handle what this land throws at you."
    },
    "help": {
      "title": "Walking Italia",
      "howTo": "How to walk Italia",
      "drag": "Drag",
      "dragDesc": "roam the land",
      "scroll": "Scroll",
      "scrollDesc": "lean in, lean out",
      "clickHex": "Click a hex",
      "clickHexDesc": "walk there (costs resolve)",
      "clickEnemy": "Click an enemy",
      "clickEnemyDesc": "start trouble",
      "standStronghold": "Stand on a stronghold",
      "standDesc": "take the ground",
      "clansNote": "Eight factions hold this land, each under its own colour. Ruined insulae and the flooded river don't move for anybody."
    },
    "fight": {
      "challenge": "A challenge on the road",
      "health": "Health",
      "attack": "Attack",
      "defense": "Defense",
      "gated": "This ground answers to a fiercer clan. Reach level {level} before you can fight here.",
      "lowHealth": "You're at {pct}% health — consider patching up first.",
      "groundTakeover": "Ground takeover",
      "garrison": "Beat the {family} garrison and the banner over {name} changes tonight.",
      "raidersAtGate": "Raiders at the gate",
      "defendNote": "{family} raiders hold your gate. Break the siege before the window closes, or {name} is theirs.",
      "walkAway": "Walk away",
      "startFight": "Start the fight",
      "takeGround": "Take the ground",
      "breakSiege": "Break the siege",
      "furyCost": "1 resolve",
      "mobInfo": "{name} · Lv {level} · {cash} folles",
      "estateInfo": "{family} — {name}",
      "rewardFolles": "+{amount} folles",
      "rewardXp": "+{amount} XP",
      "rarity": {
        "common": "Common",
        "elite": "Elite",
        "mythic": "Mythic"
      }
    },
    "furyDescEta": ", full in {fullIn}",
    "siegeBroken": "Siege broken — {name} holds",
    "siegeWarning": "{name} is under siege — {hrs}h {min}m to answer or lose it",
    "takenKicker": "The standard comes down",
    "takenTitle": "{name} is yours",
    "takenFrom": "Taken from {family}",
    "takenDesc": "It pays tribute from now on. Go to the Estates to collect it — and to improve the estate so it pays more.",
    "takenCta": "To the Estates",
    "lv": "Lv {level}"
  },
  "districts": {
    "rivalClan": "Rival faction",
    "upForGrabs": "Up for grabs",
    "collected": "Collected {amount} folles from {name}",
    "upgraded": "{name} tribute raised to Lv {level} — {rent} folles",
    "groundHeld": "Ground held",
    "scouted": "Scouted",
    "takeHome": "Take-home",
    "collecting": "Collecting…",
    "collectAll": "Take the whole rent — {amount}",
    "loading": "Reading the tablets…",
    "rent": "Rent",
    "perHour": "/hr",
    "collect": "Collect",
    "raise": "Raise",
    "takeOnMap": "Take it on the map",
    "breakSiege": "Break the siege",
    "walkRoads": "Walk the roads",
    "sealed": "Sealed · needs Lv {level}",
    "empty": "Walk Italia and survey them.",
    "collectedAll": "Collected {amount} folles from all estates",
    "upgradeKicker": "The estate",
    "upgradeTitle": "Raise {name} to Lv {level}?",
    "upgradeTributeLabel": "Tribute",
    "upgradeTributeValue": "Lv {from} → {to}",
    "upgradeCostLabel": "Cost",
    "upgradeNote": "An improved estate yields more each cycle and stands harder against a raid.",
    "upgradeConfirm": "Raise it",
    "heldByYou": "held by you",
    "heldUnderSiege": "held by you — UNDER SIEGE",
    "siegeGatePrefix": "Raiders at the gate —",
    "siegeGateSuffix": "to answer, or the estate is lost",
    "lv": "Lv {level}/{max}",
    "upgradeTooltip": "Raise the tribute — {cost} folles",
    "unreadMilestones": "{count} milestone stands unread beyond the dust | {count} milestones stand unread beyond the dust",
    "tilesAway": "{count} tile away | {count} tiles away",
    "nextRaidIn": "Raiders return in",
    "maxLevelReached": "MAX LEVEL REACHED",
    "collectIn": "Ready in {time}",
    "garrison": "Garrison"
  },
  "clans": {
    "kicker": "The Curia",
    "errorNeedNameTag": "A faction needs a name and a tag.",
    "loading": "Reading the tablets…",
    "foundingFee": "Founding fee",
    "createTitle": "Raise [{tag}] {name}?",
    "createNote": "You become its leader. The fee is paid to the treasury and does not come back.",
    "carveStone": "Inscribe the tablet",
    "createdToast": "[{tag}] {name} stands — you lead it",
    "joinTitle": "Swear into [{tag}] {name}?",
    "joinNote": "A plea goes to their leader — if they let you in, your points count toward their tablet while you stay. Walking out later locks you out of factions for a day.",
    "askToJoin": "Ask to join",
    "pleaSentToast": "Your plea is with [{tag}] {name} — the leader will answer.",
    "pleaPending": "Plea sent",
    "cancelPlea": "Take it back",
    "pleaCanceledToast": "Plea taken back.",
    "pleasHeading": "Pleas at the gate",
    "letIn": "Let in",
    "turnAway": "Turn away",
    "letInToast": "{username} swears to the standard.",
    "turnedAwayToast": "The plea is turned away.",
    "swearIn": "Swear in",
    "joinedToast": "Sworn into [{tag}] {name}",
    "leaveTitle": "Walk out of [{tag}] {name}?",
    "leaveNoteSolo": "You are the last name on the tablet — leaving dissolves the faction.",
    "leaveNoteLeader": "You lead this faction — the longest-standing member takes it over.",
    "leaveNoteMember": "Your points stay yours; the faction just stops counting them.",
    "leaveNoteSuffix": "You will not be able to join or found another faction for 24 hours.",
    "walkOut": "Walk out",
    "leftToast": "You walk alone again",
    "kickTitle": "Cast {username} out?",
    "thisClansman": "this member",
    "kickNote": "Their points leave with them, and the door stays shut on them for a day.",
    "castOutButton": "Cast out",
    "castOutConfirm": "Cast them out",
    "kickedToast": "{username} walk alone now",
    "theyDefault": "They",
    "factionSub": "{sworn} of {max} sworn · points are the living sum of every member's age points — they reset when the age does",
    "clanPoints": "faction points",
    "nameless": "Nameless",
    "leaderTitle": "Faction leader",
    "factionFootNote": "Walking out locks you out of factions for 24h.",
    "yourMark": "your mark",
    "uncarved": "uninscribed",
    "foundHeading": "Raise your own faction",
    "foundSub": "A name, a tag, and 200 solidi — gather your friends and farm the age under one standard. No oaths beyond the tag: your points count toward the tablet while you stay.",
    "nameLabel": "Faction name",
    "namePlaceholder": "Sons of the Grey Sun…",
    "tagLabel": "Tag · 2–5",
    "bannerLabel": "The standard",
    "tagPlaceholder": "GREY",
    "rollHeading": "The faction roll",
    "searchPlaceholder": "Find a faction — name or tag…",
    "searchAriaLabel": "Find a faction",
    "rollCount": "{shown} of {total}",
    "rollSub": "Every faction of the age, strongest first — find one here and ask to join. The leader answers every plea.",
    "emptyHeading": "No tablets inscribed yet",
    "emptyBody": "Factions raised by anyone in Italia will stand here — you swear in straight from this roll. Or raise your own above and let others find you.",
    "noMatch": "No tablet carries that name or tag.",
    "bandSworn": "{count}/{max} sworn",
    "points": "points",
    "yourFaction": "your faction",
    "law1": "One faction per name — swear in, or inscribe your own.",
    "law2": "The tablet's points are the living sum of every sworn member's age points.",
    "law3": "Twenty sworn at most; the longest-standing inherits a leaderless faction.",
    "law4": "Walk out — or get cast out — and no faction takes you for a day."
  },
  "dungeons": {
    "title": "Descents",
    "sub": "Deep descents, chamber by chamber — wounds carry over, resolve buys the way in",
    "confirm": {
      "kicker": "Scout the descent",
      "title": "Descend into {name}?",
      "confirm": "Descend",
      "rooms": "Rooms",
      "doorCharge": "Door charge",
      "fullTake": "Full spoils",
      "note": "Damage carries chamber to chamber — turn back early and you keep what you banked."
    },
    "noFury": {
      "title": "Not enough resolve",
      "yours": "Your resolve",
      "eta": "Resolve returns — enough for this gate in about {min} min.",
      "note": "Resolve returns over time, or the Supplies stall restores it now.",
      "toSupplies": "To the Supplies"
    },
    "backToRaid": "Back to the descent",
    "finishFirst": "Finish your descent first",
    "raidIt": "Descend",
    "loading": "Scouting the descents…",
    "inProgress": "Descent in progress",
    "ageXp": "Age XP",
    "firstClear": "First clear",
    "offLimits": "Off limits — reach level {level} to descend",
    "smoldering": "Sealed — ready in {time}",
    "soon": {
      "title": "Faction Descents",
      "body": "Great descents against the lords of the underworld — opened only from ground your faction holds. Stand on the right land when the omens turn, or the gate stays shut."
    }
  },
  "market": {
    "title": "The Forum",
    "sub": "Buy · sell · weigh in",
    "tabs": {
      "rack": "The Stalls",
      "supplies": "Supplies & Favors",
      "sell": "Sell",
      "weighing": "Moneychanger's Table",
      "weighingFull": "Moneychanger's Table — change solidi into folles"
    },
    "confirm": {
      "forum": "The Forum",
      "quickSell": "Quick sell",
      "broker": "The broker",
      "supplies": "Supplies & Favors",
      "amphora": "The Sealed Amphora"
    },
    "rows": {
      "piece": "Piece",
      "price": "Price",
      "streetValue": "Street value",
      "youGetNow": "You get now"
    },
    "buyIt": "Buy it",
    "sellIt": "Sell it",
    "pull": "Pull",
    "sellNote": "Instant payout, half the street value — and sold is sold.",
    "toast": {
      "bought": "Bought {name} — it's in your bag",
      "acquired": "Acquired {name} — it's in your bag",
      "quickSold": "Quick-sold — +{amount} folles",
      "brokerOut": "At the broker — +{amount} folles in {time}",
      "brokerCleared": "The broker paid out — +{amount} folles"
    },
    "blocked": {
      "chestFull": "Strongbox full",
      "notEnough": "Not enough funds",
      "fullHealth": "Full health",
      "fullFury": "Full resolve",
      "dailyLimit": "Daily limit",
      "alreadyHeld": "Already held",
      "active": "Active",
      "levelLocked": "Requires Level {level}"
    },
    "buy": "Buy",
    "short": "Short",
    "weighIn": "Exchange",
    "shortOnSolidi": "Short on solidi",
    "filters": {
      "slot": "Slot",
      "rarity": "Rarity",
      "all": "All",
      "currency": "Currency",
      "folles": "Folles",
      "solidi": "Solidi",
      "search": "Search",
      "searchPlaceholder": "Name, set or effect",
      "more": "More filters",
      "showing": "{shown} of {total}",
      "reset": "Reset filters",
      "price": "Price",
      "min": "Min",
      "max": "Max",
      "priceNote": "Compared in the coin each piece is paid in; folles and solidi are never mixed.",
      "myLevel": "Usable at Lv {level}",
      "canBuy": "Can buy now"
    },
    "sort": {
      "label": "Sort by",
      "featured": "Featured first",
      "priceAsc": "Price: low to high",
      "priceDesc": "Price: high to low",
      "levelAsc": "Level: lowest first",
      "levelDesc": "Level: highest first",
      "rarityDesc": "Rarity: rarest first",
      "powerDesc": "Power: strongest first",
      "nameAsc": "Name: A to Z"
    },
    "empty": {
      "noMatch": "Nothing matches those filters.",
      "noMatchHint": "Loosen a filter or clear them all to see the whole rack.",
      "nothingHere": "Nothing here yet."
    },
    "noBonuses": "No bonuses",
    "amphora": {
      "title": "The Sealed Amphora",
      "desc": "A sealed jar from a dead man's cellar — could hold anything."
    },
    "strongbox": {
      "title": "Strongbox Expansion",
      "slots": "+{count} slots",
      "maxed": "Maxed · {count}"
    },
    "sellBag": {
      "title": "Your bag ({count})",
      "empty": "Nothing unequipped to sell.",
      "sellFrom": "Sell from the bag",
      "pickSomething": "Pick something from the bag on the left.",
      "fetchingQuote": "Fetching a quote…",
      "equippedNote": "Equipped gear can't be sold. Take the instant cut, or broker it for more."
    },
    "quickSell": "Quick-sell",
    "instantLose": "Instant · you lose {pct}%",
    "brokerIt": "Broker it",
    "atBroker": "At the broker · {time}",
    "losePct": "You lose ({pct}%)",
    "takeAmount": "Take {amount}",
    "brokersCut": "Broker's cut ({pct}%)",
    "payoutIn": "Payout in {hours}h",
    "brokerLockNote": "The item goes to the broker now; the folles clear after a {hours}-hour lock. Sold is sold.",
    "brokerFor": "Broker for {amount}",
    "lv": "Lv {level}",
    "rarity": {
      "common": "Common",
      "uncommon": "Uncommon",
      "rare": "Rare",
      "epic": "Epic",
      "legendary": "Legendary",
      "mythic": "Mythic"
    }
  },
  "counting": {
    "kicker": "Moneychanger's desk",
    "popular": "Popular",
    "bestRate": "Best rate",
    "toast": "+{amount} folles — counted clean",
    "confirm": {
      "kicker": "The Moneychanger's Table",
      "solidiIn": "Solidi in",
      "youGet": "You get",
      "weighIn": "Exchange",
      "weighInPackage": "Exchange {name}?",
      "weighInAmount": "Exchange {amount} solidi?"
    },
    "bronzeFolles": "Bronze folles",
    "gross": "Gross {amount}",
    "notEnough": "Not enough solidi",
    "weighIn": "Exchange",
    "shortOnSolidi": "Short on solidi",
    "shortNotice": "Short {n} solidi for this exchange — the Treasury sells them.",
    "getSolidi": "Get solidi",
    "slate": "Moneychanger's tablet",
    "customAmount": "Name your own amount",
    "tally": {
      "gross": "Gross",
      "changerCut": "Changer's cut {pct}%",
      "credited": "Credited"
    },
    "weighInCustom": "Exchange custom",
    "purseThin": "Purse running thin?"
  },
  "inventory": {
    "title": "The Strongbox",
    "slots": "slots",
    "all": "All",
    "empty": "Nothing stored away yet. Fights and descents will fill this out.",
    "worn": "Worn",
    "broken": "Broken",
    "tier": "T{tier}"
  },
  "items": {
    "slots": {
      "weapon": "Weapon",
      "helmet": "Helmet",
      "armor": "Armour",
      "boots": "Boots",
      "ring": "Ring",
      "amulet": "Amulet"
    },
    "stats": {
      "firepower": "Damage",
      "toughness": "Toughness",
      "cunning": "Cunning",
      "reflexes": "Reflexes",
      "health": "Health",
      "fpr": "DMG",
      "tuf": "TUF",
      "cun": "CUN",
      "rfx": "RFX",
      "firepowerDesc": "How hard you hit. Each round it is set against the foe's Toughness — what gets through comes off their health.",
      "toughnessDesc": "Your guard. Shaves incoming damage before it reaches your health.",
      "cunningDesc": "Augury and guile. Half of your Cunning counts as extra Damage in every fight.",
      "reflexesDesc": "Quickness of hand and foot — the mark of a fighter who travels light."
    },
    "modal": {
      "worn": "Worn",
      "set": "{name} set",
      "contributing": "Contributing",
      "vsEquipped": "Vs. equipped",
      "statsLabel": "Stats",
      "durability": "Durability",
      "upgrade": "Sharpen — {from} / {max} → {to} / {max}",
      "maxLevel": "Fully sharpened ({max} / {max}).",
      "equip": "Equip",
      "unequip": "Unequip",
      "upgradeAction": "Upgrade · {cost} folles",
      "repairAction": "Repair · {cost} folles",
      "sell": "Sell",
      "buy": "Buy · {price}",
      "equipped": "Equipped {name}",
      "unequipped": "Unequipped {name}",
      "upgraded": "{name} sharpened to {level} / {max}",
      "repaired": "Repaired {name}",
      "sold": "Sold {name} for {amount} folles",
      "forge": "The forge",
      "repairTitle": "Repair {name}?",
      "upgradeTitle": "Upgrade {name}?",
      "price": "Price",
      "repair": "Repair",
      "quickSell": "Quick sell",
      "sellTitle": "Sell {name}?",
      "sellNote": "Instant payout, half its worth in folles — and sold is sold.",
      "payout": "Payout",
      "follesAmount": "{amount} folles",
      "solidiAmount": "{amount} solidi",
      "sellIt": "Sell it",
      "level": "Sharpening",
      "tier": "Tier {tier}"
    },
    "confirm": {
      "forge": "The forge",
      "repair": "Repair {name}?",
      "upgrade": "Upgrade {name}?",
      "quickSell": "Quick sell",
      "sellTitle": "Sell {name}?",
      "sellNote": "Instant payout, half its worth in folles — and sold is sold.",
      "price": "Price",
      "level": "Level",
      "payout": "Payout",
      "repairBtn": "Repair",
      "upgradeBtn": "Upgrade",
      "sellBtn": "Sell it"
    }
  },
  "jobs": {
    "title": "The Commission Board",
    "newSlate": "New tablet · {time}",
    "bigScores": "Long work turns · {time}",
    "doneToday": "{done}/{total} done today",
    "collectAll": "Collect all — {count} paydays",
    "collecting": "Collecting…",
    "loading": "Opening the books…",
    "daily": {
      "title": "Daily commissions",
      "blurb": "Quick work. The tablet is wiped at midnight — unclaimed pay is wiped with it."
    },
    "weekly": {
      "title": "The long work",
      "blurb": "Heavy work for those who finish what they start. A full week to deliver."
    },
    "empty": "No commissions posted. The estate is quiet — too quiet.",
    "collect": "Collect",
    "settled": "Settled",
    "onErrand": "On a commission",
    "errandTooltip": "Still working this one — progress ticks as you play. Come back once it's done to collect.",
    "toast": {
      "payday": "Payday — {name}: {details}",
      "allCollected": "All paydays collected: {details}",
      "folles": "+{amount} folles",
      "solidi": "+{amount} solidi",
      "xp": "+{amount} XP"
    },
    "folles": "folles",
    "solidi": "solidi",
    "xp": "XP",
    "boardAria": "Commission board",
    "announce": "Collected {name}: {details}",
    "claimFailed": "The claim did not go through. Nothing was paid — try again.",
    "progressAria": "{done} of {total} done",
    "nextSlate": "Next slate",
    "lockedBody": "All paid. New work is posted in {time}"
  },
  "rankings": {
    "title": "Rankings",
    "sub": "Italia keeps score",
    "loading": "Reading the inscriptions…",
    "boardLoading": "Turning the pages…",
    "age": "Age {n}",
    "you": "You",
    "unknown": "Unknown",
    "ledger": "The ledger of names",
    "yourMark": "Your mark",
    "promoted": "Promoted to {tier} — {folles} folles{solidi} paid out",
    "tier": {
      "onPromotion": "On promotion:",
      "folles": "folles",
      "atAgeClose": "at the end of the age",
      "paidAtClose": "paid when the age ends",
      "now": "Now:"
    },
    "ageEnd": "End of the age in {time}",
    "ageEndNote": "When the count runs out, the age ends as the haruspices foretold: the last rewards are paid and the world begins anew.",
    "agePoints": "age points",
    "standing": "Standing:",
    "pointsFrom": "{points} points from",
    "topOfLadder": "nobody stands higher",
    "points": {
      "sources": "Points come from fights won (1 + the foe’s level), ground taken (+25), sieges broken (+12) and Amphitheatre wins (+15).",
      "lossLead": "Losing in the Amphitheatre",
      "lossCost": "costs 7",
      "lossTail": "— a creature that beats you takes only blood and gear-wear.",
      "payout": "Every promotion pays out on the spot; the end of the age pays the big rewards."
    },
    "of": "of {n}",
    "omitted": "ranks omitted",
    "youPoints": "You — {points} points",
    "emptyBoard": "No one has made their mark yet. The first page of history is blank."
  },
  "tutorial": {
    "skip": "Skip",
    "back": "Back",
    "next": "Next",
    "carveMyName": "Inscribe my name",
    "demoCaption": "Click a glowing hex next to you to walk there.",
    "steps": {
      "welcome": {
        "title": "Welcome to Italia, 536",
        "body": "The sun shines like the moon and frost falls in summer. The whole map is one dying land, split into 8 faction grounds. You start here — at the bottom of every tally, with nothing but what you're wearing. The factions above you earned their ground. Now earn yours."
      },
      "walk": {
        "title": "Walk the old roads",
        "body": "Open the map and click a hex next to you to move. Every step costs resolve — and Italy is wide."
      },
      "fog": {
        "title": "Fog of war",
        "body": "You only see what's around you. Walk into the dust to reveal the map."
      },
      "fight": {
        "title": "Fight what's next to you",
        "body": "Enemies sit on tiles. Click one to start trouble — the outcome depends on your stats, your gear, and a bit of fortune."
      },
      "gear": {
        "title": "Gear up",
        "body": "Wins drop loot — equip it, upgrade it, sell what you don't need."
      },
      "ground": {
        "title": "Take ground",
        "body": "Reach a faction's stronghold on the map and beat the garrison. The estate is yours until someone takes it back."
      },
      "amphitheatre": {
        "title": "The Amphitheatre",
        "body": "Fight other players in the Amphitheatre — ranked bouts that settle scores and move the leaderboard."
      },
      "raids": {
        "title": "Descents",
        "body": "Make Descents into catacombs and necropolises — multi-chamber gauntlets where damage carries and the spoils grow with every gate."
      },
      "climb": {
        "title": "Climb the boards",
        "body": "Ground taken, battles won, arsenal value — every board has a ladder. Top them to be remembered."
      },
      "forum": {
        "title": "The Forum",
        "body": "Over a hundred pieces across five rarity tiers — and the whole catalogue is ALWAYS on the shelves. Nothing rotates out, nothing sells out: what you see today is there tomorrow. New gear also drops from fights as loot."
      },
      "gearwear": {
        "title": "Your gear is yours — but it wears",
        "body": "Nobody can take what you own: lose a fight, lose your ground — your kit stays. What it does do is WEAR: every fight chips it, and at zero it breaks. A broken piece counts for NOTHING until you repair it (costs {cash}, priced by rarity and wear). Upgrade it 1→5 for +10% a level, or quick-sell what you don't need."
      }
    },
    "currency": {
      "folles": "folles",
      "solidi": "solidi",
      "fury": "resolve"
    }
  },
  "chat": {
    "listening": "Listening…",
    "unknown": "Unknown",
    "placeholder": "Speak from the Rostra…",
    "speak": "Speak"
  },
  "chest": {
    "kicker": "The seal breaks",
    "note": "Stored in your strongbox.",
    "takeIt": "Take it",
    "rewardAria": "Chest reward"
  },
  "recover": {
    "kicker": "Quick recovery",
    "price": "Price",
    "buyIt": "Buy it",
    "furyRestored": "Resolve restored — back on the road",
    "healthRestored": "Mended to full health",
    "buyName": "Buy {name}?"
  },
  "buySlots": {
    "kicker": "Strongbox expansion",
    "slots": "Slots",
    "price": "Price",
    "expand": "Expand",
    "toast": "Strongbox expanded — +{count} slots",
    "title": "Buy {count} more strongbox slots",
    "notEnough": "Not enough solidi",
    "maxed": "Maxed · {count}",
    "titleAttr": "Buy {count} more strongbox slots"
  },
  "faq": {
    "label": "Laws of the land",
    "loading": "Loading…",
    "empty": "No FAQ entries yet.",
    "heading": "FAQ"
  },
  "legalPanel": {
    "title": "Legal",
    "companyNumber": "Company number:",
    "registeredAddress": "Registered address:",
    "contact": "Contact:",
    "lastUpdated": "Last updated {date}"
  },
  "legalPage": {
    "metaDescription": "The papers of Caligo 536 in full: terms of service, privacy and cookies.",
    "home": "Back to the home page"
  },
  "cookieNotice": {
    "label": "Cookie notice",
    "body": "We use only essential cookies to keep you signed in, and keep your language and sound settings on your device. No tracking, no ads.",
    "policy": "Cookie Policy",
    "ok": "Understood"
  },
  "heroCard": {
    "follesRush": "Bronze Rush x1.5",
    "xpBoost": "XP Booster x1.5",
    "reviveReady": "Revive ready",
    "health": "Health",
    "level": "Level {level}",
    "fury": "Resolve",
    "healthRegen": "+5 HP a minute — back to full in {time}",
    "furyRegen": "+1 resolve every 2.5 minutes — next in {time}",
    "slotEmpty": "{slot} — empty",
    "lvAbbr": "Lv",
    "fullIn": "full in {time}",
    "nextIn": "+1 in {time}"
  },
  "heroDossier": {
    "title": "Service record — combat dossier",
    "health": "Health",
    "fury": "Resolve",
    "ofMax": "of {max} max",
    "setBonuses": "Set bonuses",
    "pc": "pc",
    "setBonusEmpty": "Equip 2+ pieces of a set to activate its bonus.",
    "classAbility": "Class ability",
    "cooldown": "{n}-round cooldown",
    "maneuvers": "Maneuvers",
    "tapHint": "Tap a stat to read what it does in a fight.",
    "healthDesc": "Your life pool. Whatever gets past your Toughness comes off this — hit zero and the fight is lost. It refills on its own between fights, or mid-fight with a Patch Up.",
    "furyDesc": "The fuel for everything: starting a fight costs 1, and every hex you cross on the map has its resolve price. It refills on its own over time — Quick Recovery hurries it for folles."
  },
  "heroScreen": {
    "referralBonus": "Referral bonus: +{amount} folles",
    "welcome": "Welcome to the faction, {name}",
    "getFolles": "Get folles — change solidi at the Moneychanger's Table",
    "buySolidi": "Buy solidi at the Treasury",
    "refillFury": "Restore resolve — Flask of Posca at the Forum",
    "furyNext": "Next resolve in {time} or restore it now at the Forum",
    "loading": "Loading…",
    "naming": {
      "kicker": "The Census Tablets · Italia",
      "heading": "Inscribe your name",
      "sub": "Four callings are open to the desperate. Write your name under one of them.",
      "placeholder": "e.g. Marcus Aurelianus",
      "pickTrade": "Pick a calling"
    },
    "theForum": "The Forum",
    "pvpLockedTitle": "Finish the bout first",
    "sections": "Sections",
    "soundOn": "Turn the sound on",
    "soundOff": "Silence music and sound"
  },
  "confirmDialog": {
    "defaultKicker": "Weigh it",
    "defaultConfirm": "Confirm",
    "defaultCancel": "Walk away"
  },
  "abilities": {
    "WARRIOR": {
      "name": "Testudo Breaker",
      "desc": "A veteran's drilled thrust from behind the shield — a guaranteed crushing blow, ×2.2 damage."
    },
    "PALADIN": {
      "name": "Sol Invictus",
      "desc": "Call on the Unconquered Sun — mend 30% max HP and shrug off the next hit, no retaliation."
    },
    "ARCHER": {
      "name": "Lance Charge",
      "desc": "A mounted charge through the enemy line — ×2.0 damage, ignores defense."
    },
    "MAGE": {
      "name": "Ill Omen",
      "desc": "Read their doom in the liver — bleeding for 6% max HP a round, 2 rounds."
    },
    "strike": {
      "name": "Strike",
      "desc": "Standard attack — 15% crit chance for ×1.8 damage."
    },
    "heavy": {
      "name": "Heavy",
      "desc": "75% chance to hit for ×1.7 damage; on a miss it whiffs entirely. Incoming hits land harder (×1.4) that round."
    },
    "guard": {
      "name": "Guard",
      "desc": "Your damage out is cut to ×0.6; damage taken is halved, with a 20% chance to block it outright."
    }
  },
  "legalOverlay": {
    "kicker": "Caligo 536 · By Edict",
    "stamp": "Filed with the Curia",
    "loading": "Fetching the paperwork…",
    "errorTitle": "Not on file",
    "errorBody": "This document could not be retrieved right now. Try again in a moment, or write to us instead."
  },
  "guide": {
    "title": "The Codex",
    "subtitle": "Why we're here, and how Italy is held",
    "back": "Back",
    "replay": "Replay the walkthrough",
    "goal": {
      "heading": "The goal",
      "body": "You start a Refugee — no name, no ground, no say in anything. Every follis earned, every estate taken, and every bout won pulls you one rung up the ladder: Refugee, Colonus, Plebeian, Eques, Senator, and at the top, Patrician — the one every faction in Italia answers to. There's no single way up. Grow your strength, grow your coin, grow the ground you hold — all three feed the climb."
    },
    "loop": {
      "heading": "The loop",
      "intro": "No single grind carries you to the curule chair. The days fall into a rhythm — do this, spend there, and the next move opens up.",
      "step1": {
        "title": "Take your commissions",
        "body": "Steady folles, no risk. The Commission board resets daily and weekly — the safest coin in Italia, and the first stop every day."
      },
      "step2": {
        "title": "Gear up at the Forum",
        "body": "Spend those folles on weapons, armour, and supplies. A sharper blade wins fights a duller one loses."
      },
      "step3": {
        "title": "Fight for it",
        "body": "Take the fight to the creatures holding the map, or make a descent into a guarded necropolis. Both spend resolve and both pay in folles, gear, and standing."
      },
      "step4": {
        "title": "Take ground, hold it",
        "body": "Estates you control pay you tribute even while you're away — steady folles for as long as you can keep them."
      },
      "step5": {
        "title": "Duel for rank",
        "body": "Step into the Amphitheatre and put your name against another player's. Winning is the fastest climb there is."
      }
    },
    "screens": {
      "heading": "Where everything lives",
      "intro": "Every screen does one job. Here's what each one is for.",
      "map": {
        "title": "Italia (Map)",
        "body": "Walk the roads, find creatures to fight, and push into contested ground."
      },
      "estates": {
        "title": "Estates",
        "body": "See who holds which estate, claim ground of your own, and collect the tribute it pays. Hold it, too: raiders lay siege from time to time — return to the stronghold and break them within the window, or the estate is lost."
      },
      "errands": {
        "title": "Commissions",
        "body": "Your daily and weekly commission board — safe, steady folles for work already done."
      },
      "market": {
        "title": "The Forum",
        "body": "Buy and sell weapons, armour, and supplies; restore your resolve here too."
      },
      "amphitheatre": {
        "title": "The Amphitheatre",
        "body": "Formal one-on-one bouts against another player — the fast road to rank."
      },
      "raids": {
        "title": "Descents",
        "body": "Multi-chamber descents into guarded catacombs, richer spoils than a roadside fight, and a cooldown to respect after."
      },
      "inventory": {
        "title": "The Strongbox",
        "body": "Your gear and stores, kept on your Hero page — equip, inspect, and manage what you carry."
      },
      "settings": {
        "title": "Settings",
        "body": "Your account, language, sound, and billing — the wax tablets of who you are."
      }
    },
    "economy": {
      "heading": "Folles & solidi",
      "folles": {
        "title": "Bronze folles",
        "body": "The coin you earn by playing — commissions, tribute, fights, descents. It buys gear, restores your resolve, and keeps the lamps lit."
      },
      "solidi": {
        "title": "Gold solidi",
        "body": "The premium coin. Solidi buy convenience and speed — nothing that decides a fight sits behind them."
      },
      "repair": "Restoring your resolve always costs folles, never solidi."
    },
    "risk": {
      "heading": "What's actually at stake",
      "intro": "This age is not gentle, but it's not a trap either. Here's exactly what a fight can cost you.",
      "fury": {
        "title": "Resolve spent",
        "body": "Every creature fight, descent, or bout spends resolve the moment you start it — win or lose, that resolve is gone. Restore it at the Forum when it runs low."
      },
      "cooldown": {
        "title": "Descent cooldowns",
        "body": "Clear a necropolis and it goes quiet for a while before you can descend again — the dead have to settle."
      },
      "duel": {
        "title": "A lost bout",
        "body": "Lose in the Amphitheatre and no rank lands from that bout — you simply walk away with nothing gained, not with something taken."
      },
      "gear": "Your gear stays yours. Nothing you own is ever stripped from you for losing a fight."
    },
    "ranks": {
      "r1": "Refugee",
      "r2": "Colonus",
      "r3": "Plebeian",
      "r4": "Eques",
      "r5": "Senator",
      "r6": "Patrician"
    },
    "gear": {
      "heading": "Gear: buy it, wear it, mend it",
      "intro": "Nothing you own is ever taken from you — but everything you swing wears out. The whole life of an item:",
      "buy": {
        "title": "Buy it",
        "body": "The Forum keeps the full catalogue on the stalls at all times — weapons, helmets, armour, boots, rings, amulets — for folles, plus a few Treasury pieces for solidi."
      },
      "wear": {
        "title": "It wears",
        "body": "Every fight you finish chips 1 durability off every equipped piece — win or lose. The wear bar on the item shows exactly how much life is left."
      },
      "broken": {
        "title": "It breaks",
        "body": "At zero durability the piece breaks. It stays in your Strongbox — nothing is ever lost — but a broken piece gives zero stats: you are fighting bare-handed, and fights you used to win start going the other way."
      },
      "repair": {
        "title": "Repair it",
        "body": "Open the Strongbox, tap the piece, pay folles — full durability, full stats, same item. Repair early: the price scales with wear, so a half-worn piece costs half of a dead one."
      },
      "costs": "A full repair runs 20 / 45 / 90 / 180 / 400 folles by rarity (Common → Legendary) at level 1 — each upgrade level adds 10%, and partial wear is priced proportionally."
    },
    "clans": {
      "heading": "Factions — names inscribed together",
      "intro": "A faction is a standard over the leaderboard, not a second army. Here is exactly how it works today.",
      "found": {
        "title": "Found or join.",
        "body": "Found your own faction for 500 folles — a name, a short tag, a standard — or join any open faction for free. One faction per player, up to 20 members; leaving puts you on a cooling-off before another faction takes you. If the leader walks, the longest-standing member inherits; an empty faction dissolves."
      },
      "points": {
        "title": "The sum of names.",
        "body": "The faction score is the live sum of its members’ age points, reset when the age ends. Amphitheatre bouts feed it hardest — ranked wins pay the steepest points — and your tag rides beside your name on every leaderboard."
      },
      "wars": {
        "title": "No faction wars — yet.",
        "body": "There are no faction wars, faction descents or shared strongboxes yet. Today the faction is a pact of ambition: players farming points under one tag, each in their own fights. War between standards is on the roadmap."
      }
    },
    "moves": {
      "heading": "The moves & resolve",
      "intro": "Every round you pick one move. Resolve is one pool for everything — the same points a march across the land spends. Strike and guard are free; the special strikes burn resolve (a bigger body burns more), and running costs a flat 2. An empty pool never blocks a move — it just means you march on nothing but will.",
      "strike": {
        "title": "Strike",
        "body": "Your bread-and-butter cut. Free. Damage rides your attack against their defense, with a 15% chance to crit."
      },
      "heavy": {
        "title": "Heavy blow",
        "body": "A wilder swing: about 1.7x the damage when it lands (3 in 4 do), but you eat a harder counter. Burns resolve."
      },
      "guard": {
        "title": "Guard",
        "body": "Trade 40% of your own cut to halve theirs, with a 1-in-5 full block. Free — but turtling decays: past two guards in a row the testudo cracks."
      },
      "ability": {
        "title": "Class ability",
        "body": "Your calling’s signature move, on a cooldown. Burns resolve. Hover or tap its card in the fight for the exact terms."
      },
      "flee": {
        "title": "Flee",
        "body": "Run for it — 60% odds on the road (5% in the Amphitheatre, where a flight settles as a loss). Costs a flat 2 resolve."
      },
      "heal": {
        "title": "Patch-up",
        "body": "Not a round action: mend 35% of your health mid-fight, up to three times, for solidi."
      },
      "flask": "The Flask of Posca: once per fight you can restore your resolve for solidi — same price the Forum asks."
    }
  },
  "map": {
    "legend": {
      "button": "Legend",
      "title": "Reading the land",
      "subtitle": "What you're looking at out there — and how much it'll bite.",
      "terrainHeading": "The ground",
      "costLabel": "Move cost {cost}",
      "impassableLabel": "Impassable",
      "terrain": {
        "block": {
          "name": "Ashfield",
          "desc": "Open fields under grey dust. Easy going."
        },
        "street": {
          "name": "Roman Road",
          "desc": "Paved consular road — the fastest way across the land."
        },
        "rubble": {
          "name": "Rubble",
          "desc": "Fallen masonry under ash. Easy footing."
        },
        "park": {
          "name": "Apennine Wood",
          "desc": "Dark oak and chestnut. Slower going — enemies like the cover."
        },
        "slums": {
          "name": "Marsh",
          "desc": "Ravenna's reed-choked marshes. Slow, and worse things than men hide in the reeds."
        },
        "warzone": {
          "name": "Battlefield",
          "desc": "Gothic War dead unburied in the frost. Slow going, and where most trouble lurks."
        },
        "stronghold": {
          "name": "Stronghold",
          "desc": "A faction's seat. Beat their garrison to take the estate."
        },
        "bridge": {
          "name": "Bridge",
          "desc": "The only safe crossing over the flooded river."
        },
        "river": {
          "name": "Flooded River",
          "desc": "Cold, fast and swollen with ash-mud. Impassable."
        },
        "highrise": {
          "name": "Ruined Insula",
          "desc": "A collapsed tenement block, walled off by its own rubble. Impassable."
        }
      },
      "enemyHeading": "Enemies",
      "enemy": {
        "markerDesc": "A face in a faction-coloured ring is a hostile band — the bigger the disc, the tougher the fighter. They're hidden by the dust until you're close enough to see them.",
        "strengthNote": "Every estate has a tier, and a band's strength climbs with it. Your level decides whether that's a fair fight.",
        "tierHeading": "Tier ladder",
        "tierRow": "Tier {tier} · needs Lv {level}",
        "tier1": "Starving refugees and feral dogs — desperate, not deadly.",
        "tier2": "Deserters and wolves — low-level muscle.",
        "tier3": "Marauders and fauns — hardened muscle.",
        "tier4": "Striges and lemures — the restless dead.",
        "tier5": "Versipelles and lamiae — real trouble.",
        "tier6": "Cynocephali and blemmyes — omens made flesh.",
        "tier7": "Furies, basilisks and the catoblepas — dangerous beyond reason.",
        "tier8": "The manticore — and, rarely, a lord of the underworld.",
        "danger": {
          "safe": "Safe",
          "risky": "Risky",
          "deadly": "Deadly"
        }
      },
      "otherHeading": "On the map",
      "other": {
        "you": {
          "name": "Your marker",
          "desc": "The portrait in the red-ochre ring under the glow — that's you. On the minimap you are the red dot."
        },
        "fog": {
          "name": "Fog of war",
          "desc": "Bright ground is in sight now. Dimmed ground you've already scouted. Black ground you haven't seen yet."
        },
        "estate": {
          "name": "Faction estates",
          "desc": "Coloured ground and the thick border mark a faction's territory. The ringed hex is their stronghold — crest, name and tier float above it."
        },
        "path": {
          "name": "Move preview",
          "desc": "Bronze tiles show the route and its resolve cost before you commit to a hex."
        }
      },
      "mythic": "Mythic bosses — Cerberus at Avernus, Dis Pater in the deep — ringed in gold at the dark edges of the map. They demand the highest unlock level and pay beyond any faction's champion."
    }
  },
  "levelUp": {
    "kicker": "The omens turn",
    "level": "Level {level}",
    "levelsAtOnce": "{count} level at once | {count} levels at once",
    "hp": "Health",
    "attack": "Damage",
    "defense": "Toughness",
    "magic": "Cunning",
    "grants": "The gods grant",
    "unlocks": "Now open to you",
    "raid": "Descent opened: {name}",
    "wares": "{count} new ware at the Forum | {count} new wares at the Forum",
    "continue": "Onward",
    "close": "Close"
  },
  "offerPopup": {
    "kickerLevel": "A purse for your new rank",
    "kickerPeriodic": "The Treasury whispers",
    "leadLevel": "Level {level} reached. The Treasury marks the day with a purse below the base rate.",
    "leadPeriodic": "A purse set aside for you: more solidi for your coin, while the offer stands.",
    "save": "Save {percent}%",
    "cta": "See the deal",
    "notNow": "Not now",
    "close": "Close"
  },
  "install": {
    "title": "Install Caligo 536",
    "hintNative": "Put Caligo 536 on your home screen — free, no app store.",
    "hintIos": "Tap {share}, then {add}.",
    "hintMac": "In the menu bar: {file} → {add}.",
    "hintIosMenu": "In the browser menu: {share}, then {add}.",
    "hintFirefox": "In the ⋮ menu: {add}.",
    "shareLabel": "Share",
    "addLabel": "Add to Home Screen",
    "fileLabel": "File",
    "dockLabel": "Add to Dock",
    "cta": "Install",
    "dismiss": "Dismiss"
  },
  "codex": {
    "title": "Caligo 536 — The Codex: A Player's Guide",
    "skip": "Skip to the Codex",
    "hero": {
      "kicker": "Anno Domini 536 · the year without a sun",
      "title": "The Codex",
      "lede": "A dust veil hides the sun, the harvest has failed and the Gothic War burns across Italia. This is everything you need to rise from refugee to patrician."
    },
    "idx": {
      "ranks": "Ranks",
      "callings": "Callings",
      "provinces": "Provinces",
      "foes": "Foes",
      "combat": "Combat",
      "gear": "Gear",
      "coin": "Coin & Resolve",
      "estates": "Estates",
      "raids": "Raids",
      "amphitheatre": "Amphitheatre",
      "households": "Households",
      "market": "Market"
    },
    "ranks": {
      "h": "The Ladder of Rank",
      "intro": "Every won fight, taken estate and Amphitheatre bout earns rank points within the current era (30 days). Each promotion pays out the moment you reach it, and the end of the era pays the great rewards.",
      "col": {
        "rank": "Rank",
        "points": "Points",
        "promotion": "On promotion",
        "era": "At era's end"
      },
      "r1": "Refugee",
      "r2": "Colonus",
      "r3": "Plebeian",
      "r4": "Eques",
      "r5": "Senator",
      "r6": "Patrician",
      "note": "A won fight is worth <b>1 point plus the foe's level</b>; taking an estate <b>25</b>; holding one against a siege <b>12</b>."
    },
    "callings": {
      "h": "The Four Callings",
      "intro": "Every hero starts with these exact figures. Gear adds to them; the calling decides your strengths and your one special art in combat.",
      "centurion": {
        "n": "Veteran Centurion",
        "p": "Shield and formation: the heaviest guard of the four with a hard blow behind it, and almost no cunning.",
        "a": "Testudo Breaker — a guaranteed crushing blow. Every 3 rounds."
      },
      "mithraist": {
        "n": "Mithraist",
        "p": "Soldier-initiate of the unconquered sun: damage and toughness in balance, and the best cunning after the Haruspex.",
        "a": "Sol Invictus — heal and shrug off the next blow. Every 4 rounds."
      },
      "gothicJarl": {
        "n": "Gothic Jarl",
        "p": "A mounted Gothic lord: the hardest hitter and by far the quickest, paid for with thin armour.",
        "a": "Riding Shot — a cold, armour-piercing shot from the saddle. Every 3 rounds."
      },
      "haruspex": {
        "n": "Haruspex",
        "p": "Etruscan reader of livers and omens: cunning beyond anyone, and the frailest body in Italia.",
        "a": "Evil Omen — the foe bleeds for two rounds. Every 3 rounds."
      }
    },
    "stats": {
      "dmg": {
        "h": "Damage",
        "p": "How hard you hit. Set against the foe's toughness each round."
      },
      "tuf": {
        "h": "Toughness",
        "p": "Your guard. It shaves incoming damage before it reaches your health."
      },
      "cun": {
        "h": "Cunning",
        "p": "Omen-craft and guile. Half of it counts as extra damage in every fight."
      },
      "rfx": {
        "h": "Reflexes",
        "p": "Quickness of hand and foot, the mark of a fighter who travels light."
      }
    },
    "provinces": {
      "h": "The Provinces of Italia",
      "intro": "Italia is one hex map under the dust veil. You only see ground you have scouted; every step costs resolve, and woods, marsh and old battlefields cost double. Each province is held by its own household of foes.",
      "campania": "Grey vineyards and failed fields, where most heroes begin.",
      "naples": {
        "n": "Bay of Naples",
        "text": "Quays, beggars and harbour toughs."
      },
      "avernus": {
        "n": "Lake Avernus",
        "text": "Sulphur shores at the gate of the underworld."
      },
      "cumae": "The Sibyl's cave, now a Gothic stronghold.",
      "rome": {
        "n": "Rome",
        "text": "A half-empty city of senators and ruins."
      },
      "ravenna": "The Gothic court among the marshes.",
      "apennines": {
        "n": "Apennines",
        "text": "Oak, chestnut and what hunts beneath them."
      },
      "etruria": "Necropolis country of the old haruspices.",
      "appian": {
        "n": "Appian Way",
        "text": "Milestones, gibbets and cutpurses."
      },
      "flaminian": {
        "n": "Flaminian Way",
        "text": "The northern road to the war."
      },
      "sicily": {
        "n": "Sicilian Ports",
        "text": "Grain ships and wreckers."
      },
      "alps": {
        "n": "Alpine Marches",
        "text": "Snowbound passes at the edge of Italia."
      }
    },
    "foes": {
      "h": "Foes by Tier",
      "intro": "Six kinds of foe roam the map. Each province dresses them in its own colours, but the strength beneath is the same. Every one pays folles and experience when it falls.",
      "brigand": {
        "n": "Starving Refugee",
        "p": "70 health. The easiest fight on the road."
      },
      "militia": {
        "n": "Deserter",
        "p": "220 health. Still safe for a fresh hero."
      },
      "brute": {
        "n": "Bonebreaker",
        "p": "600 health. Bring gear before you swing."
      },
      "assassin": {
        "n": "Feral Dog Pack",
        "p": "800 health, fast and vicious."
      },
      "veteran": {
        "n": "Grey Wolf",
        "p": "1,000 health. A real test of your build."
      },
      "warlord": {
        "n": "Brigand Chief",
        "p": "3,500 health. The master of an estate, with the payout to match."
      },
      "note": "Deeper in the dust wait stranger things: lemures and larvae, striges, versipelles, lamiae, Furies, and the manticore and basilisk as world bosses."
    },
    "combat": {
      "h": "Combat",
      "intro": "Fights are turn by turn. Each round you choose one action; the foe answers.",
      "strike": {
        "n": "Strike",
        "p": "The standard blow. Reliable damage."
      },
      "heavy": {
        "n": "Heavy",
        "p": "A harder blow that can miss and leave you open."
      },
      "guard": {
        "n": "Guard",
        "p": "Cuts the incoming blow. Lean on it round after round and it weakens."
      },
      "ability": {
        "n": "Calling art",
        "p": "Your calling's special move, on a cooldown between uses."
      },
      "heal": {
        "n": "Bind wounds",
        "p": "Restores 35% of your health without spending the round. Three times per fight."
      },
      "flee": {
        "n": "Flee",
        "p": "A chance to escape before the fight finishes you."
      }
    },
    "gear": {
      "h": "Gear & Rarity",
      "intro": "Weapons, helmets, armour, boots, rings and amulets come in six rarities. Every fight wears 1 durability off each piece you wear; a broken piece keeps its place in your strongbox but gives no stats until repaired.",
      "common": "Common",
      "repair": {
        "common": "Full repair: 20 folles",
        "uncommon": "Full repair: 45 folles",
        "rare": "Full repair: 90 folles",
        "epic": "Full repair: 180 folles",
        "legendary": "Full repair: 400 folles",
        "mythic": "Full repair: 900 folles"
      },
      "uncommon": "Uncommon",
      "rare": "Rare",
      "epic": "Epic",
      "legendary": "Legendary",
      "note": "Repair prices are for level 1: each upgrade level adds 10%, and partial wear costs proportionally less.",
      "mythic": "Mythic"
    },
    "coin": {
      "h": "Coin, Resolve & Commissions",
      "folles": {
        "n": "Bronze folles",
        "p": "Earned by playing: fights, tribute, commissions and raids. They buy gear and pay for repairs."
      },
      "solidi": {
        "n": "Gold solidi",
        "p": "The premium coin, worth 100 folles each. It buys speed and convenience."
      },
      "resolve": {
        "n": "Resolve",
        "p": "Your will to act. Moving, fighting and raiding spend it. It refills one point every 2.5 minutes; the pool starts at 10 and grows with level to 12."
      },
      "jobs": {
        "h": "Commissions",
        "p": "Daily commissions pay folles and experience for things you would do anyway: clear the roads, walk your estate, scout the old roads, win three Amphitheatre bouts, learn the provinces, run the grain."
      }
    },
    "estates": {
      "h": "Estates & Tribute",
      "intro": "Beat an estate's garrison to take it. It then pays tribute in folles every hour, up to its storage cap, and you can build it up through six levels.",
      "col": {
        "level": "Level",
        "income": "Folles / hour",
        "cap": "Storage",
        "cost": "Upgrade cost"
      },
      "note": "The old owners come back. When raiders lay siege you have <b>12 hours</b> to return and break them, or the estate is theirs again."
    },
    "raids": {
      "h": "Raids & Descents",
      "intro": "Raids are chains of rooms ending in a boss. Each room pays its share as you clear it, and every raid rests for 72 hours after you finish it.",
      "col": {
        "raid": "Raid",
        "level": "From level",
        "resolve": "Resolve",
        "boss": "Boss"
      },
      "tavern": {
        "text": "The Tavern Raid",
        "boss": "The Steward"
      },
      "barge": {
        "text": "The Grain-Barge Plunder",
        "boss": "The Harbourmaster"
      },
      "avernus": "The Descent at Avernus",
      "dis": "The Hall of Dis Pater",
      "cerberus": {
        "p": "The three-headed hound of the lake shore. 560 health."
      },
      "dispater": {
        "p": "Lord of the dead beneath Italia. 1,100 health."
      }
    },
    "arena": {
      "h": "The Amphitheatre",
      "intro": "Ranked bouts, player against player. Every fighter starts at a rating of 1000.",
      "cost": {
        "n": "The entry",
        "p": "Each bout costs 1 resolve."
      },
      "win": {
        "n": "A win",
        "p": "+15 rating, +15 rank points and 50 folles."
      },
      "loss": {
        "n": "A loss",
        "p": "−17 rating, −17 rank points and up to 100 folles. Walking away from a revealed foe costs 5 rating."
      }
    },
    "households": {
      "h": "Households",
      "found": {
        "n": "Found or join",
        "p": "Found a household for 200 folles with a name, a tag and a standard, or join an open one for free. Up to 20 members."
      },
      "score": {
        "n": "The sum of names",
        "p": "A household's score is the sum of its members' rank points in the current era. Your tag rides beside your name on every leaderboard."
      },
      "leave": {
        "n": "Leaving",
        "p": "After leaving, you wait 24 hours before another household will take you. If the leader leaves, the longest-standing member inherits."
      }
    },
    "market": {
      "h": "The Market",
      "buy": {
        "n": "Buy",
        "p": "The full catalogue is always in stock for folles, and some pieces can be paid in solidi instead."
      },
      "quick": {
        "n": "Quick sale",
        "p": "Sell instantly and keep half the item's value."
      },
      "broker": {
        "n": "The broker",
        "p": "Keep 90% of the value, paid out after a 12-hour hold."
      }
    },
    "finale": {
      "kicker": "No download · free to play",
      "h": "Italia waits under the veil",
      "p": "You know the rules now. Choose a calling and take your first step."
    },
    "metaDescription": "The Caligo 536 Codex: callings, the provinces of Italia, foes, combat, gear, folles and solidi, estates, raids, the Amphitheatre and households."
  },
  "chronicle": {
    "kicker": "Posted in the forum · Anno 536",
    "title": "The Chronicle",
    "subtitle": "The public record of Italy under the veiled sun — decrees, campaigns, feasts and the fortunes of the great houses.",
    "filter": "Filter the record",
    "tag": {
      "all": "All",
      "updates": "Decrees",
      "events": "Events",
      "patch": "Patch Notes",
      "family": "House News"
    },
    "latest": "Latest entry",
    "read": "Read the entry",
    "readMore": "Read",
    "entryNo": "Entry",
    "empty": "Nothing has been posted in the forum yet. Return at dusk.",
    "error": "The record could not be fetched. Try again shortly.",
    "pages": "Pages of the record",
    "article": {
      "back": "The Chronicle",
      "readNext": "Further entries",
      "ctaHeading": "Italy waits beneath the veil",
      "ctaButton": "Enter the year 536",
      "missingTitle": "This entry was never posted.",
      "missingBody": "The page you seek is not in the record. It may have been withdrawn, or the link has faded.",
      "missingBack": "Return to the Chronicle",
      "metaDescription": "An entry from The Chronicle of Caligo 536."
    },
    "metaDescription": "The Chronicle of Caligo 536: decrees, events, patch notes and house news from Italy in the year without a sun."
  },
  "site": {
    "skip": "Skip to content"
  }
}
